var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimpleIconsX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.3037 4.216H82.797L53.317 37.5298L88 82.8531H60.8447L39.578 55.3611L15.2387 82.8531H1.738L33.2713 47.2194L0 4.21963H27.8447L47.069 29.3481L69.3037 4.216ZM64.57 74.8709H72.0463L23.782 11.7814H15.7593L64.57 74.8709Z",
    fill: "#191919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleIconsX);
export default __webpack_public_path__ + "static/media/simple-icons_x.69b181677805a500f579f81a1aa2c068.svg";
export { ForwardRef as ReactComponent };